<app-back-home />

<app-user-management
    [isLoading]="isLoading()"
    [delegatesEnabled]="delegatesEnabled"
    [users]="users()"
    [total]="total()"
    (searchChanged)="updateSearch($event)"
    (userAdded)="addUser($event)"
    (userEdited)="editUser($event)"
    (userDeleted)="deleteUser($event)"
    (pageChange)="pageChange($event)"
    [page]="(pageOptions()?.page ?? 0) + 1"
    [pageSizeOptions]="pageSizeOptions"
/>
